import { render, staticRenderFns } from "./ReviewCaseList.vue?vue&type=template&id=261185c7&scoped=true"
import script from "./ReviewCaseList.vue?vue&type=script&lang=js"
export * from "./ReviewCaseList.vue?vue&type=script&lang=js"
import style0 from "./ReviewCaseList.vue?vue&type=style&index=0&id=261185c7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261185c7",
  null
  
)

export default component.exports